export const clerkAppearance: any = {
  variables: {
    colorPrimary: "#7c3aed",
    colorBackground: "#ffffff",
    colorText: "#111827",
    colorTextSecondary: "#4b5563",
    colorInputBackground: "#f9fafb",
    colorInputText: "#111827",
    colorNeutral: "#e5e7eb",
    colorDanger: "#ef4444",
    borderRadius: "0.875rem",
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  elements: {
    userButtonPopoverCard: "bg-white shadow-xl border border-gray-200 text-gray-900",
    userButtonPopoverActionButton: "hover:bg-gray-100 text-gray-900 font-medium transition-colors opacity-100",
    userButtonPopoverActionButtonText: "text-gray-900 font-semibold opacity-100",
    userButtonPopoverActionButtonIcon: "text-gray-700 opacity-100",
    userButtonPopoverFooter: "bg-white border-t border-gray-200 text-gray-600",
    userPreviewMainIdentifier: "text-gray-900 font-semibold",
    userPreviewSecondaryIdentifier: "text-gray-500 font-normal",
  },
}

export const clerkAuralisAppearance: any = {
  variables: {
    colorPrimary: "#d97706",
    colorBackground: "#ffffff",
    colorText: "#111827",
    colorTextSecondary: "#4b5563",
    colorInputBackground: "#ffffff",
    colorInputText: "#111827",
    colorNeutral: "#e5e7eb",
    colorDanger: "#dc2626",
    borderRadius: "0.75rem",
    fontFamily: '"Geist", "Inter", sans-serif',
  },
  elements: {
    card: "bg-transparent shadow-none w-full border-none p-0",
    headerTitle: "hidden",
    headerSubtitle: "hidden",
    socialButtonsBlockButton: "bg-white border border-gray-200 hover:bg-gray-50 text-gray-900 font-semibold shadow-sm transition-all flex items-center justify-center gap-2 py-2.5 rounded-xl",
    socialButtonsBlockButtonText: "text-gray-900 font-semibold text-sm",
    formButtonPrimary: "bg-amber-600 hover:bg-amber-700 text-white font-bold shadow-md transition-all rounded-xl py-2.5 text-sm",
    formButtonPrimaryText: "text-white font-bold",
    formFieldInput: "bg-white border border-gray-200 text-gray-900 shadow-sm focus:ring-2 focus:ring-amber-500 focus:border-amber-500 rounded-xl px-3.5 py-2.5 text-sm",
    formFieldLabel: "text-gray-700 font-semibold text-xs mb-1",
    dividerLine: "bg-gray-200",
    dividerText: "text-gray-400 text-xs font-semibold uppercase tracking-wider",
    footer: "bg-white border-t border-gray-100 rounded-b-2xl py-3 px-4 text-center",
    footerAction: "bg-white text-gray-600 text-sm font-medium",
    footerActionText: "text-gray-600 font-medium",
    footerActionLink: "text-amber-600 hover:text-amber-700 font-bold transition-colors",
    devModeNotice: "bg-white text-amber-600 font-mono text-[11px] font-semibold tracking-wide border-t border-gray-100 py-2 text-center w-full",
    identityPreviewText: "text-gray-800 font-semibold",
    identityPreviewEditButton: "text-amber-600 hover:text-amber-700 font-semibold",
  }
}


